<template>
  <div class="r_h_100">
    <div class="r_h_100" v-if="!ass_loaded">
      <loadingCube :loadingMessage="'ASSIGNMENT'"></loadingCube>
    </div>
    <div v-else id="assignment_right_info">
      <div id="ri_w_top">
        <button class="btn orcaBtn grey_bg" id="right_info_close" data-toggle="tooltip" title="Close information" @click="close_right_info">
          <i class="fas fa-times"></i> &nbsp;CLOSE
        </button>
        <div class="quick_btns">
          <button v-if="assignment.assigned" @click="end_assignment(assignment)" class="btn orcaBtn danger mb-2 mr-1 ml-1" data-toggle="tooltip" title="End Assignment">
            End Assignment
          </button>
          <div v-else class="mb-3">&nbsp;<br></div>
        </div>

        <hr class="mt-1 mb-2">

        <div>
          <div class="d-inline-block" style="width: 280px">
            <h2 class="font-weight-bold bp_color mb-0 d-inline-block">{{ assignment.worker.person.first_name }} {{ assignment.worker.person.surname }}</h2>
            <h5 class="mb-2">{{ assignment.order_job.rel_order_position.job_title }}</h5>
          </div>

          <div class="row">
            <div class="col-xl-4 font-weight-bold">Pay Rate:</div>
            <div class="col-xl-8">{{ assignment.position_rate.pay_amount | currency }}</div>
            <div class="col-xl-4 font-weight-bold">Admin Rate:</div>
            <div class="col-xl-8">
              <span v-if="assignment.position_rate.admin_fee_type === '£ (Pound)'">{{ assignment.position_rate.admin_fee_amount | currency }}</span>
              <span v-if="assignment.position_rate.admin_fee_type === '% (Percentage)'">{{ assignment.position_rate.admin_fee_amount | percentage }}</span>
            </div>
            <div class="col-xl-4 font-weight-bold">Duration:</div>
            <div class="col-xl-8">{{ assignment.start_date | formatDate }} - {{ assignment.end_date | formatDate }}</div>
          </div>
          <p class="pt-1 mb-0 font-italic" style="font-size: 0.65rem;">
            Assigned By {{ assignment.assigned_by.first_name }} {{ assignment.assigned_by.surname }} on {{ assignment.created_at | formatDateTime }}
          </p>
        </div>

      </div>
      <div class="ri_w_after_top">
        <div class="ri_w_section">
          <div class="row">
            <div class="col-12">
              <h5 class="mb-3">Order Information</h5>
              <h5 class="bp_color">{{ assignment.order_job.order_ref }}</h5>
            </div>
          </div>
          <button @click="show_order" class="btn orcaBtn sm-btn top_right_btn" data-toggle="tooltip" title="View Order">View Order</button>
          <div class="row">
            <div class="col-12" v-if="check_expiring !== ''">
              <div class="expiry_warning" v-if="check_expiring === 'expiring'">Expiring within 2 weeks</div>
              <div class="expired" v-if="check_expiring === 'expired'">expired</div>
            </div>
            <div class="col-xl-5 font-weight-bold">Order Duration:</div>
            <div class="col-xl-7">{{ assignment.order_job.rel_order_position.start_date | formatDate }} - {{ assignment.order_job.rel_order_position.end_date | formatDate }}</div>
            <div class="col-xl-5 font-weight-bold">Short Site Name:</div>
            <div class="col-xl-7">{{ assignment.order_job.rel_order_location.short_site_name }}</div>
            <div class="col-xl-5 font-weight-bold">Job Location:</div>
            <div class="col-xl-7">{{ assignment.order_job.rel_order_location.job_address_full }}</div>
            <div class="col-12">
              <hr>
            </div>
          </div>
        </div>
        <div class="ri_w_section">
          <div class="row">
            <div class="col-12">
              <h5 class="mb-3">Client Information</h5>
              <h5 class="bp_color">{{ assignment.company.company_name }}</h5>
            </div>
          </div>
          <button @click="show_client" class="btn orcaBtn sm-btn top_right_btn" data-toggle="tooltip" title="View Client">View Client</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {mapActions} from "vuex";
import loadingCube from "loaders/right_loader";

export default {
  name: "assignment",
  components: {
    loadingCube
  },
  data() {
    return {
      ass_loaded: false,
      assignment: {}
    }
  },
  beforeMount() {
    this.assignment = this.$store.state.right_info.data;
    this.$nextTick(() => this.ass_loaded = true);
  },
  computed: {
    check_expiring() {
      let end_date = this.$moment(this.assignment.order_job.rel_order_position.end_date).utc();
      let end_date_14_days_before = this.$moment(this.assignment.order_job.rel_order_position.end_date).utc().subtract(14, 'days');
      // is after end date
      if (this.$moment().utc().isAfter(end_date)) {
        return 'expired'
      }
      else if (this.$moment().utc().isAfter(end_date_14_days_before)) {
        return 'expiring'
      }
      else {
        return ''
      }
    },
  },
  methods: {
    ...mapActions(['hideRightInfo']),

    /*
     * QUICK ACTIONS
     */
    close_right_info() {
      this.hideRightInfo();
      this.$store.commit('CLEAR_RIGHT_INFO_TABLE_ROW');
    },
    end_assignment(assignment) {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">End Assignment</div>' +
            '<div class="snotifyToast__body">' +
            'Are you sure you wish to end the assignment for:<br><br>' +
            '<strong class="mb-2 d-block">' + assignment.worker.person.first_name + ' ' + assignment.worker.person.surname + '</strong>' +
            '<strong class="mb-2 d-block">' + assignment.order_job.order_ref + '</strong>' +
            '<strong class="mb-2 d-block">' + assignment.company.company_name + '</strong>' +
            '<strong class="mb-2 d-block">' + assignment.order_job.rel_order_position.job_title + '</strong>' +
            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
            '</div>',
        buttons: [
          {
            text: 'End Assignment', action: (toast) => {
              assignment.assigned = false;
              assignment.end_date = this.$moment().utc().format('YYYY-MM-DD')
              assignment.log_by_type = 'App\\Models\\Users\\User';
              assignment.log_by_id = this.$store.state.auth.me.id;
              axios.post(this.crmApiPath + 'timesheet/record/end_assignment/' + assignment.id).then(() => {
              axios.patch(this.crmApiPath + 'assignments/worker_assignments/' + assignment.id, assignment).then(() => {

                  this.$snotify.remove(toast.id);
                  this.close_right_info();
                  this.$bus.$emit('assignments::reload', {action: true});
                })
              })
            }
          },
          {
            text: 'Cancel', action: (toast) => {
              this.$snotify.remove(toast.id)
            }
          }
        ]
      });
    },

    show_order() {
      this.$store.commit('CURRENT_ORDER_ID', this.assignment.order_job_id);
      this.$store.commit('SET_ORDER_TAB_INDEX', 0);
      this.$nextTick(() => {
        this.$router.push('/order/view');
        this.$tabs.refresh('/order/view', true)
      });
    },

    show_client() {
      this.$store.commit('CURRENT_RECORD_COMPANY_ID', this.assignment.client_id);
      this.$store.commit('SET_COMPANY_TAB_INDEX', 0);
      this.$nextTick(() => {
        this.$router.push('/company/record');
        this.$tabs.refresh('/company/record', true)
      });
    }
  }
}
</script>

<style scoped lang="scss">
.r_h_100 {
  height: calc(100vh - 43px);
}

#assignment_right_info {
  width:       $right_info_width;
  padding-top: 0;

  .row {
    margin-right: 0;
    margin-left:  0;

    &.extra_neg_margin {
      margin-right: -10px;
      margin-left:  -10px;
    }
  }

  #ri_w_top {
    position:         fixed;
    height:           200px;
    background-color: $right_info_bg;
    right:            0;
    width:            400px;
    padding:          10px 20px 10px 10px;
    z-index:          9;
  }

  .ri_w_after_top {
    padding-top:    212px;
    width:          100%;
    padding-bottom: 20px;
    padding-right:  20px;
  }

  .quick_btns, .quick_action_btns {
    .orcaBtn {
      width:       auto;
      padding:     0 15px;
      line-height: 30px;
      font-size:   0.65rem;
    }
  }

  .ri_w_section {
    display:  block;
    position: relative;

    .sm-btn {
      width:       auto;
      padding:     0 15px;
      line-height: 30px;
      font-size:   0.65rem;
      float:       right;
    }

    .top_right_btn {
      position: absolute;
      right:    5px;
      top:      -5px;
    }

    .ri_w_label {
      display:       inline-block;
      line-height:   30px;
      margin-bottom: 0;
    }

    .ri_w_no_content {
      background:     $red;
      padding-top:    5px;
      padding-bottom: 5px;

      .ri_w_label {
        color: $white;
      }
    }

    .ri_w_loading {
      display:       inline-block;
      line-height:   30px;
      margin-bottom: 0;
      font-size:     1rem;
    }
  }

  .expiry_warning, .expired {
    line-height:    30px;
    text-align:     center;
    color:          $white;
    margin-top:     0;
    border-radius:  $border-radius;
    font-weight:    bold;
    text-transform: uppercase;
    margin-bottom:  10px;
  }

  .expiry_warning {
    background: $orange;
  }

  .expired {
    background: $red;
  }

}

</style>
